import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { ComponentMeta, ComponentStory } from '@storybook/react'

import Typography from 'components/UI/Typography/Typography'

import typoArgs, { TypographyArgs } from './TypographyArgs'

export default {
  title: 'Typography',
  component: Typography.BodySmallBold,
} as ComponentMeta<typeof Typography.BodySmallBold>

const BodySmallBoldTemplate: ComponentStory<typeof Typography.BodySmallBold> = (
  args: TypographyArgs,
) => <Typography.BodySmallBold {...args} />

const BodySmallBold = BodySmallBoldTemplate.bind({})
BodySmallBold.args = typoArgs

export { BodySmallBold }
